import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { InteractorResponse } from '../../models/interactor-response';
import { AppConstants } from '../../constants/app-constants';
import { AbstractNotificationTemplateApiService } from '../abstract/abstract-notification-template-api-service';
import { NotificationTemplateModel, ParameterModel } from 'src/app/store/notification-template/model';

const baseUrl = `/api/messageTemplates`;

@Injectable()
export class NotificationTemplateApiService extends AbstractNotificationTemplateApiService {
  private http = inject(HttpClient);

  getAllNotificationTemplates(): Observable<InteractorResponse<NotificationTemplateModel[]>> {
    return this.http.get<InteractorResponse<NotificationTemplateModel[]>>(`${baseUrl}`);
  }

  getNotificationTemplateById(id: number): Observable<InteractorResponse<NotificationTemplateModel>> {
    return this.http.get<InteractorResponse<NotificationTemplateModel>>(`${baseUrl}/${id}`);
  }

  saveNotificationTemplate(template: NotificationTemplateModel): Observable<InteractorResponse<NotificationTemplateModel>> {
    return this.http.post<InteractorResponse<NotificationTemplateModel>>(`${baseUrl}`, template);
  }

  getParameters(): Observable<InteractorResponse<ParameterModel[]>> {
    return this.http.get<InteractorResponse<ParameterModel[]>>(`${baseUrl}/parameters`);
  }
}
